module.exports = __webpack_public_path__ + "img/file-pdf-solid-full.a0d41497.svg";